import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import { TextField, SelectField } from 'redux-form-material-ui';
import { reduxForm, Field } from 'redux-form';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import { required } from '../utils/form-validators';
import i18n from '../translations/i18n';

/*
  Styled components
 */
const ButtonContainer = styled.div`
  margin-top: 30;
  float: right;
`;

const StyledSubmitButton = styled(RaisedButton)`
  margin-left: 5 !important;
`;

const PlainField = styled.div`
  padding-top: 40px;
  padding-bottom: 16px;
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  isModify: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func,
  disableSave: PropTypes.any,
  initialValues: PropTypes.any,
};

const defaultProps = {
  isModify: false,
  disableSave: false,
};

const LoraConfigForm = (props) => {
  const { handleSubmit, isModify, disableSave } = props;

  const assignedPaketboxId = props.initialValues && props.initialValues.paketbox_id;

  let packetBoxLink = false;
  if (assignedPaketboxId) {
    packetBoxLink = (
      <span>
        {props.t('assigned_to_paketbox')}
        {assignedPaketboxId}
        <Link to={`/packetboxes/modify/${assignedPaketboxId}`}>
          <FlatButton primary label={props.t('view_details')} />
        </Link>
      </span>
    );
  }

  return (
    <form onSubmit={handleSubmit}>

      <Field
        component={TextField}
        validate={[required]}
        disabled={disableSave}
        name="lora_dev_eui"
        hintText={props.t('lora_dev_eui')}
        floatingLabelText={props.t('lora_dev_eui')}
        fullWidth
      />

      <Field
        component={TextField}
        validate={[required]}
        disabled={disableSave}
        name="lora_app_eui"
        hintText={props.t('lora_app_eui')}
        floatingLabelText={props.t('lora_app_eui')}
        fullWidth
      />

      <Field
        component={TextField}
        validate={[required]}
        disabled={disableSave}
        name="lora_app_key"
        hintText={props.t('lora_app_key')}
        floatingLabelText={props.t('lora_app_key')}
        fullWidth
      />

      <Field
        name="lora_provider"
        disabled={disableSave}
        component={SelectField}
        hintText={props.t('lora_provider')}
        fullWidth
        floatingLabelText={props.t('lora_provider')}
      >
        <MenuItem value="SLS" primaryText="SLS" />
        <MenuItem value="LORIOT" primaryText="Loriot" />
        <MenuItem value="FIREFLY" primaryText="Firefly" />
        <MenuItem value="SWISSCOM" primaryText="Swisscom" />
        <MenuItem value="TTN" primaryText="TTN" />
      </Field>

      <PlainField>
        {packetBoxLink}
        {isModify && !packetBoxLink && props.t('config_not_assigned')}
      </PlainField>

      <ButtonContainer>
        <Link
          onClick={() => {
            browserHistory.push('/lora-configs/');
          }}
        >
          <RaisedButton label={props.t('back')} />
        </Link>

        <StyledSubmitButton label={props.t('save')} type="submit" primary disabled={disableSave} />
      </ButtonContainer>
    </form>
  );
};

LoraConfigForm.propTypes = propTypes;
LoraConfigForm.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(LoraConfigForm);
export default reduxForm({ form: 'loraConfig' })(localize(extended, 'locale'));



// WEBPACK FOOTER //
// ./src/components/LoraConfigForm.js